import React from "react";

const DashboardTab: React.FC = () => {
  return (
    <div className="h-full overflow-y-auto">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        Panel Scout Dashboard
      </h2>
      <p className="text-gray-600">
        Overview and key metrics for Panel Scout.
      </p>
    </div>
  );
};

export default DashboardTab;
